import { takeLatest, all } from 'redux-saga/effects';
import {
  SESSION_CREATE,
  BRANDS_FETCH,
  SUBSCRIPTION_FETCH,
  SUBSCRIPTION_REQUEST,
  CARD_UPDATE_REQUEST,
  PRODUCTS_FETCH,
  PRODUCT_UPDATE_REQUEST,
} from '../../constants/actionTypes';
import { handleCreateSession } from './session';
import { handleFetchBrands } from './brand';
import {
  handleRequestSubscription,
  handleFetchSubscription,
  handleRequestUpdateCard,
  handleFetchProducts,
  handleRequestUpdateProduct,
} from './subscription';

export default function* rootSaga() {
  yield all([
    takeLatest(SESSION_CREATE, handleCreateSession),
    takeLatest(BRANDS_FETCH, handleFetchBrands),
    takeLatest(SUBSCRIPTION_FETCH, handleFetchSubscription),
    takeLatest(SUBSCRIPTION_REQUEST, handleRequestSubscription),
    takeLatest(CARD_UPDATE_REQUEST, handleRequestUpdateCard),
    takeLatest(PRODUCTS_FETCH, handleFetchProducts),
    takeLatest(PRODUCT_UPDATE_REQUEST, handleRequestUpdateProduct),
  ]);
}
